import { chain, filter, reduce } from "lodash"

const QUERY = `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
  model (id: $modelId) {
    simulation (positionSet: $positionSet, base: $base, from: $from, to: $to, interval: END_DATE) {
      performance {
        attribution {
          factors {
            id
            name
            category
            return {
              cumulativePercent
            }
          }
        }
      }
    }
  }
}`

export function createPerformanceCumulativeSingleDateQuery(modelId, positionSet, base, from, to, options = {}) {
  return {
    key: ["cumulativePerformance", "singleDate", modelId, positionSet, base, from, to],
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      from,
      to,
    },
    select: (data) => {
      const values = chain(data)
        .get("data.model.simulation.performance.0.attribution.factors")
        .thru(factors => {
          if (options.category) {
            return filter(factors, f => f.category === options.category)
          }
          return factors
        })
        .keyBy("id")
        .mapValues(({ name, return: { cumulativePercent } }) => ({
          label: name,
          value: cumulativePercent,
        }))
        .value()

      const summary = reduce(values, (acc, { value }) => acc + value, 0)

      return {
        values,
        summary,
      }
    },
  }
}
